import api from './axiosConfig';
import {
  LoginRequest,
  LoginResponse,
  SendForgotPasswordOtpRequest,
  SendForgotPasswordOtpResponse,
  VerifyForgotPasswordOtpRequest,
  VerifyForgotPasswordOtpResponse,
  ResetForgotPasswordRequest,
} from '../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const { identifier, password } = credentials;
    const isEmail = identifier.includes('@');
    const payload = isEmail
      ? { email: identifier, password }
      : { mobileNumber: identifier, password };
    const response = await api.post<LoginResponse>('/auth/login', payload);
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<Pick<LoginResponse, 'token' | 'refreshToken' | 'refreshTokenExpiresAt'>> => {
    const response = await api.post<Pick<LoginResponse, 'token' | 'refreshToken' | 'refreshTokenExpiresAt'>>('/auth/refresh-token', { refreshToken });
    return response.data;
  },

  // Revokes this browser's refresh token server-side. Anonymous endpoint, because a session is
  // usually ended once its access token has already expired.
  logout: async (refreshToken: string): Promise<void> => {
    await api.post('/auth/logout', { refreshToken });
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>('/auth/change-password', { currentPassword, newPassword });
    return response.data;
  },

  sendForgotPasswordOtp: async (payload: SendForgotPasswordOtpRequest): Promise<SendForgotPasswordOtpResponse> => {
    const response = await api.post<SendForgotPasswordOtpResponse>('/auth/forgot-password/send-otp', payload);
    return response.data;
  },

  verifyForgotPasswordOtp: async (payload: VerifyForgotPasswordOtpRequest): Promise<VerifyForgotPasswordOtpResponse> => {
    const response = await api.post<VerifyForgotPasswordOtpResponse>('/auth/forgot-password/verify-otp', payload);
    return response.data;
  },

  resetForgotPassword: async (payload: ResetForgotPasswordRequest): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>('/auth/forgot-password/reset', payload);
    return response.data;
  },
};
